import axios from '../requester';
import { API } from '../constants/api-urls';

export const getAccount = async () => axios.get(`${API.ACCOUNTS_PATH}/me`);

export const getAccountsPermissionDomain = async () =>
  axios.get(API.ACCOUNTS_PERMISSION_DOMAIN_PATH);

export const getAccounts = async () => axios.get(API.ACCOUNTS_PATH);
export const deleteAccount = async id =>
  axios.delete(`${API.ACCOUNTS_PATH}/${id}`);
export const updateAccount = async (id, data) =>
  axios.patch(`${API.ACCOUNTS_PATH}/${id}`, data);
export const changeAccountType = async (id, data) =>
  axios.patch(`${API.ACCOUNTS_PATH}/change-account-type/${id}`, data);
export const updatePinnedDashboards = async dashboardIds =>
  axios.patch(`${API.ACCOUNTS_PATH}/settings/dashboards`, dashboardIds);

export const updateAccountPermissions = async (id, data) =>
  axios.put(`${API.ACCOUNTS_PATH}/permission/${id}`, data);

export const updateAccountsBulkPermissions = async data =>
  axios.post(`${API.ACCOUNTS_PATH}/permission/bulk`, data);
